const actionTypes = {
  CLOSURE_DATA_FETCH: 'CLOSURE_DATA_FETCH',
  CLOSURE_DATA_SUCCESS: 'CLOSURE_DATA_SUCCESS',
  CLOSURE_DATA_ERROR: 'CLOSURE_DATA_ERROR',
};

export default actionTypes;
